import styled from 'styled-components';
import { Tag as TagAnt } from 'antd';
import type { TagProps } from './Tag';
import { getTagStyleByType } from './utils/getTagStyleByType';

export const StyledTag = styled(TagAnt)<TagProps>`
  &&& {
    display: flex;
    gap: 4px;
    max-width: fit-content;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 24px;
    line-height: 24px;
    padding: 0 6px;
    transition: background-color 0.35s ease;
    margin-inline-end: 8px;

    svg {
      font-size:  ${({ theme }) => theme.typography.fontSize[4]};
    }

    ${({ type }) => {
      return getTagStyleByType(type);
    }}



    // NOTE: We use property color:basic as processing due ot ant assigning a class for this keyword
    &.ant-tag-processing {
      background-color: rgb(234, 234, 234);
      border: none;
      color: rgb(89, 89, 89);
    }
  }
`;
